// @flow
// @flow-runtime warn
import React, { type Node, useMemo } from 'react';

import AccountBalanceContext from './AccountBalanceContext';
import useBalance from './useBalance';
import useBalanceHistory from './useBalanceHistory';


type Props = {
  children: Node,
}

const AccountBalanceData = ({ children }: Props) => {
  const [balance, balanceRequest, balanceLoading] = useBalance();
  const [balanceHistory, balanceHistoryRequest, balanceHistoryLoading] = useBalanceHistory();

  const contextValue = useMemo(() => ({
    content: {
      ...balance,
      history: balanceHistory,
    },
    loading: {
      balance: balanceLoading,
      history: balanceHistoryLoading,
    },
    request: {
      balance: balanceRequest,
      history: balanceHistoryRequest,
    },
  }), [
    balance,
    balanceLoading,
    balanceRequest,
    balanceHistory,
    balanceHistoryLoading,
    balanceHistoryRequest,
  ]);

  return (
    <AccountBalanceContext.Provider value={contextValue}>
      {children}
    </AccountBalanceContext.Provider>
  );
};

export default AccountBalanceData;
